export default {
  ResultItemTitle: 'Result Item',
  resultItemId: 'Result Item Id',
  resultItemDesc: 'Result Item Desciption',
  nickname: 'Nickname',
  uom: 'Unit of Measure',
  buttonNewResultItem: 'New Result Item',
  buttonDeleteResultItem: 'Delete Result Item',
  newResultItem: 'New Result Item',
  idMissing: 'Please Enter Result Item ID',
  descMissing: 'Please Enter Result Item Description',
  nicknameMissing: 'Please Enter Result Item Nickname',
  uomMissing: 'Please Enter Result Item Uom',
  confirmDeleteSelected: 'Are you sure you want to delete selected Result Item?',
  messageDeleteNotSelected: 'Please select Result Item to delete',
  editHeader: 'Edit Result Item',
  addHeader: 'Add Result Item'
}
